import { render, staticRenderFns } from "./DetailPortrait.vue?vue&type=template&id=18cb329f&scoped=true&"
import script from "./DetailPortrait.vue?vue&type=script&lang=js&"
export * from "./DetailPortrait.vue?vue&type=script&lang=js&"
import style0 from "./DetailPortrait.vue?vue&type=style&index=0&id=18cb329f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cb329f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonBlob: require('/opt/build/repo/components/ButtonComponents/ButtonBlob.vue').default})
